import '../../../assets/javascripts/vendor/analytics-browser-2.9.0-min'

window.amplitude.init(window.amplitude_key, {
  defaultTracking: true,
});

setTimeout(async () => {
  try {
    if (typeof indexedDB === 'undefined') return;
    const { sessionReplay } = await import(
      '../../../assets/javascripts/vendor/plugin-session-replay-browser-1.4.0-min'
    );
    const sessionReplayTracking = sessionReplay.plugin({
      sampleRate: 0.1,
    });
    window.amplitude.add(sessionReplayTracking);
  } catch (e) {
    // Session replay unavailable (e.g. iOS Private Browsing) or chunk failed to load
  }
}, 200)

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
                'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

// Itinerary key shared by the search and reissue funnels. It must stay identical to
// the two server-side builders it joins against — Web::TrackEventService#output_flights_key
// and CoreBooking::Segment#itinerary_key ("KBP-FRA-LH129-23JUL") — so it lives in one place.
// Returns null rather than a wrong key, mirroring the server's rescue-to-nil.
export function buildFlightsKey(flights) {
  const segments = (flights || []).flatMap(flight => flight.segments || []).filter(Boolean)
  if (!segments.length) return null

  const keys = []
  for (const segment of segments) {
    // departure_date is a localized display string ("2 Sep, Mon"); departure_datetime is
    // "YYYY-MM-DDTHH:MM". Read literally — like the server's Date.parse — so there is no
    // timezone shift and no date library (whose locale could turn JUL into ЛИП) involved.
    const parts = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/.exec(segment.departure_datetime || "")
    if (!parts) return null

    const month = MONTHS[Number(parts[2]) - 1]
    if (!month) return null

    // flight_number already carries the carrier code ("LX 1349") — do not prefix it again.
    const flightNumber = String(segment.flight_number || "").replace(/\s/g, "")
    keys.push(
      `${segment.departure_airport?.code}-${segment.arrival_airport?.code}-` +
      `${flightNumber}-${parts[3]}${month}`
    )
  }
  return keys.join(";")
}

// Shared shape for the "Search" event so the single-city and multi-city forms
// stay comparable. `spot` disambiguates a real search from the nav-bar click,
// which fires the same event name.
export function searchEventProps(fareParams, spot) {
  const flights = (fareParams && fareParams.flights) || []
  const passengers = (fareParams && fareParams.passengers) || {}

  return {
    spot: spot,
    route: flights.map(f => `${f.departure_airport_code}-${f.arrival_airport_code}`).join(";"),
    departure_dates: flights.map(f => f.departure_date).join(";"),
    flights_count: flights.length,
    adults: passengers.adults,
    children: passengers.children,
    infants: passengers.infants
  }
}

export class AmplitudeEvent {
  constructor(eventName, eventProperties, customUserId) {
    this.name = eventName
    this.properties = { ...{ platform: 'Site' }, ...eventProperties }
    this.customUserId = customUserId
    this.defaultUserId = amplitude.getUserId();
    this.setCustomUserId()
    this.sendEvent()
    this.returnDefaultUserId()
  }

  sendEvent(){
    if (this.properties) {
      amplitude.track(this.name, this.properties);
    } else {
      amplitude.track(this.name);
    }
  }

  setCustomUserId(){
    if(this.customUserId) {
      amplitude.setUserId(this.customUserId);
    }
  }

  returnDefaultUserId(){
    if(this.customUserId) {
      amplitude.setUserId(this.defaultUserId);
    }
  }
}


export class AmplitudeUserProp {
  constructor(key, value, action){
    let identify
    switch (action) {
      case "set":
        identify = new amplitude.Identify().set(key, value)
        amplitude.identify(identify);
        break;
      case "setOnce":
        identify = new amplitude.Identify().setOnce(key, value)
        amplitude.identify(identify);
        break;
      case "unset":
        identify = new amplitude.Identify().unset(key)
        amplitude.identify(identify);
        break;
    }
  }
}
